import { Grid, Space } from "../Layout";
import { Texts, Title, Media, Button } from "../Object";
const About = () => {
  const gridProps = {
    about: {
      dir: ["column", "row"],
      gap: ["80px", "40px"],
      class: "",
      layout: ["1fr 510px", '100%'],
    },
    inner: {
      dir: ['row'],
      gap: 0,
      class: '',
      layout: ['100%']
    }
  };

  return (
    <>
      <div className="l-row">
        <Space size={["160px auto 120px", "80px auto 72px"]}>
          <Grid {...gridProps.about}>
            <Media src="about/about" alt="media" class=""></Media>
            <Grid {...gridProps.inner}>
              <Title slug="about" type="single" />
              <Space size={['56px 0 72px', '40px 0 56px']}>
                <Texts slug="about/title"></Texts>
              </Space>
              <Space size={['0 0 64px', '0 0 48px']}>
                <Texts slug="about/body" />
              </Space>

              <Button slug="service" link="/service/" />
            </Grid>
          </Grid>
        </Space>
      </div>
    </>
  );
};

export default About;
